var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('Head',{on:{"getMenus":_vm.getMenus,"pathSelect":_vm.changePath}}),_c('el-container',[(_vm.menus.length > 0)?_c('Aside',{attrs:{"menus":_vm.menus,"selected":_vm.selected,"id":_vm.id}}):_vm._e(),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }